import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { useToast } from 'common/toast/hook'
import { FetchError } from 'queries'
import { fetchWithAuth } from 'queries/fetch-with-auth'
import { PortalSessionResponse } from 'queries/post-portal-session'
import { postPaymentPortalSessionURL } from 'queries/routes'

export const POST_PAYMENT_PORTAL_SESSION_ERROR = 'Couldn’t open payment management — please try again.'

export interface PostPaymentPortalSessionVariables {
  transactionId: string
  token: string | null
}

export async function postPaymentPortalSession({
  transactionId,
  token,
}: PostPaymentPortalSessionVariables): Promise<PortalSessionResponse> {
  const response = await fetchWithAuth(postPaymentPortalSessionURL(), token, {
    method: 'POST',
    body: JSON.stringify({ transaction_id: transactionId }),
  })

  if (!response.ok) {
    const { status, statusText } = response
    let cause: Error | undefined
    try {
      cause = (await response.json()) as Error
    } catch {
      cause = undefined
    }
    throw new FetchError(POST_PAYMENT_PORTAL_SESSION_ERROR, { cause }, status, statusText)
  }

  return response.json()
}

export const usePostPaymentPortalSession = (
  options?: UseMutationOptions<PortalSessionResponse, FetchError, PostPaymentPortalSessionVariables>,
) => {
  const toast = useToast()

  return useMutation<PortalSessionResponse, FetchError, PostPaymentPortalSessionVariables>(postPaymentPortalSession, {
    ...options,
    onError: (error) => toast.error(error.message),
  })
}
